export enum DialogType {
  SUCCESS,
  FAILED,
  INFO,
  WARN
}



// WEBPACK FOOTER //
// ./src/app/shared/common-dialog-notification/common.dialog.model.ts